/** Values extracted from Intercom messenger home DOM/CSS snapshot. */
export const INTERCOM_HOME_HEADER_FADE = {
  background:
    'linear-gradient(rgba(255,255,255,0) 0%, rgb(255,255,255) 100%)',
};
